module.exports = __webpack_public_path__ + "static/media/toonlink_0.1aea6d47.png";